import { z } from 'zod';

export const createRoleSchema = z.object({
  name: z
    .string()
    .min(1, 'Name is required')
    .max(100, 'Name must be 100 characters or less'),
  roleCode: z
    .string()
    .min(1, 'Code is required')
    .max(20, 'Code must be 20 characters or less')
    .regex(/^[A-Z_]+$/, 'Code must be uppercase letters and underscores only'),
  description: z
    .string()
    .max(500, 'Description must be 500 characters or less')
    .optional(),
  isActive: z.boolean(),
});

export const editRoleSchema = createRoleSchema;

export type CreateRoleFormData = z.infer<typeof createRoleSchema>;
export type EditRoleFormData = z.infer<typeof editRoleSchema>;
